import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    scorecardFilterData: []
}

const ScorecardFilterSlice = createSlice({
    name: 'ScorecardFilterSlice',
    initialState,
    reducers: {
        handleScorecardFilterData(state, action) {
            state.scorecardFilterData = action.payload
        }
    }

})

export const { handleScorecardFilterData } = ScorecardFilterSlice.actions
export default ScorecardFilterSlice.reducer